const accordion = (opener) => {
  const accordionOpener = document.querySelectorAll(opener)

  const trackInteractionType = (interactionType) => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'faqClick',
        interactionType
      })
    }
  }

  accordionOpener.forEach((item) => {
    item.addEventListener('click', () => {
      item.classList.toggle('active')
      const panel = item.nextElementSibling
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null
        trackInteractionType('accordion_close')
      } else {
        panel.style.maxHeight = `${panel.scrollHeight}px`
        trackInteractionType('accordion_open')
      }
    })
  })
}

export default accordion
